exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.right-arrow-wrapper[data-v-5354852d] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  padding: 0 16px;\n}\n.right-arrow[data-v-5354852d] {\n  width: 32px;\n}\n.bottom-arrow[data-v-5354852d] {\n  width: 32px;\n  display: none;\n  margin: 16px 0;\n}\n@media screen and (max-width: 896px) {\n.right-arrow[data-v-5354852d] {\n    display: none;\n}\n.bottom-arrow[data-v-5354852d] {\n    display: block;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5354852d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LP/atoms/StepArrow.vue
// module id = Ui8X
// module chunks = 0